module.exports = __webpack_public_path__ + "img/71.4b544e4a.svg";